<!-- <div class="form-field">
  <label *ngIf="label" [class]="nclass">{{ label }}:&nbsp;</label>
  <span class="value" [title]="value">&nbsp;{{ value }}</span>
</div> -->

<div class="form-field justify-between">
  @if (label) {
    <label [class]="nclass" [for]="inputName">{{ label }}:&nbsp;</label>
  }
  @if (Type ? false : true) {
    <span [class]="noflex ? 'valuenoflex' : 'value'" [title]="value">&nbsp;{{ value }}</span>
  }
  @if (Type === 'InputSwitchReadonly') {
    <span [class]="noflex ? 'valuenoflex' : 'value'" [title]="value">&nbsp;{{ value ? 'Yes' : 'No' }}</span>
  }
  @if (Type === 'Date') {
    <span [class]="noflex ? 'valuenoflex' : 'value'" [title]="value">&nbsp;{{ formatDate(value) }}</span>
  }
  @if (Type === 'InputText') {
    <mat-form-field class="w-50" appearance="outline">
      <input matInput [(ngModel)]="value" [name]="inputName" />
    </mat-form-field>
  }
  @if (Type === 'InputSwitch') {
    <mat-slide-toggle
      [ngModel]="value"
      (change)="onSwitchChange($event)"
      data-cy="GlobalRuleToggleBtn"
      [name]="inputName"
    ></mat-slide-toggle>
  }
  @if (Type === 'InputCalendar') {
    <mat-form-field appearance="outline">
      <input matInput [matDatepicker]="picker" [(ngModel)]="value" [name]="inputName" />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  }
  @if (Type === 'Link') {
    <a class="hyper" [title]="value" (click)="goToLink(value)">&nbsp;{{ value }}</a>
  }
</div>
